(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trust-custom"] && !Shopify.designMode) return;
  try {
    
// Lazy load and autoplay the video when the trust section enters viewport
document.addEventListener("DOMContentLoaded", function () {
  const section = document.getElementById("trust-video-container");
  if (!section) return; // Exit if section not found

  const video = section.querySelector("video");
  const source = video.querySelector("source");
  let hasLoaded = false;

  // IntersectionObserver to watch when section is visible
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasLoaded) {
        // Replace data-src with src attribute to trigger video loading
        if (source.dataset.src) {
          source.src = source.dataset.src;
          video.load();
          video.play();
        }

        hasLoaded = true;
        observer.unobserve(section); // Stop observing after load
      }
    });
  }, {
    threshold: 0.5 // Trigger when 50% visible
  });

  observer.observe(section);
});

  } catch(e) { console.error(e); }
})();
})();
